import React from 'react';
import { CheckCircle2, AlertCircle, RotateCcw, FileText } from 'lucide-react';
import { stripRichText } from './richText';

export const getStatusColor = (status: string): string => {
  const colors: Record<string, string> = {
    draft: 'bg-gray-500/10 text-gray-700 border-gray-500/30',
    completed: 'bg-emerald-500/10 text-emerald-700 border-emerald-500/30',
    in_progress: 'bg-blue-500/10 text-blue-700 border-blue-500/30',
    revision_requested: 'bg-orange-500/10 text-orange-700 border-orange-500/30'
  };
  return colors[status] || colors.in_progress;
};

export const getStatusIcon = (status: string): React.ReactElement => {
  const icons: Record<string, React.ReactElement> = {
    draft: <FileText className="w-4 h-4" />,
    completed: <CheckCircle2 className="w-4 h-4" />,
    in_progress: <AlertCircle className="w-4 h-4" />,
    revision_requested: <RotateCcw className="w-4 h-4" />
  };
  return icons[status] || icons.in_progress;
};

export const getWordCount = (text: string): number => {
  const plainText = stripRichText(text);
  return plainText.trim().split(/\s+/).filter(Boolean).length;
};
